import { render } from "./CatalogoServicios.vue?vue&type=template&id=244906da&scoped=true"
import script from "./CatalogoServicios.vue?vue&type=script&lang=js"
export * from "./CatalogoServicios.vue?vue&type=script&lang=js"

import "./CatalogoServicios.vue?vue&type=style&index=0&id=244906da&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244906da"]])

export default __exports__